module.exports = require("./sl-SI");